export default __webpack_public_path__ + "static/media/paperclip.2def8931.svg";